import { RowCrudStatus } from "../../common/types";
import {
  AiSearchToolCall,
  AiSearchToolCall_CreateInput,
  AiSearchToolCall_UpdateInput,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";
import { safeJsonParse } from "../../../common/utils";

export type AiSearchToolCallValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  sequence: number;
  toolName: string;
  pattern: string;
  navigationPath: string;
  toolArguments: string;
  result: string;
  durationMs: number;
  success: boolean;
  errorMessage: string;
};

export type AiSearchToolCallErrorsType = {
  sequence?: { message: string; fieldLabel: string };
  toolName?: { message: string; fieldLabel: string };
  pattern?: { message: string; fieldLabel: string };
  navigationPath?: { message: string; fieldLabel: string };
  toolArguments?: { message: string; fieldLabel: string };
  result?: { message: string; fieldLabel: string };
  durationMs?: { message: string; fieldLabel: string };
  success?: { message: string; fieldLabel: string };
  errorMessage?: { message: string; fieldLabel: string };
};

export function AiSearchToolCallValuesInit(): AiSearchToolCallValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    sequence: 0,
    toolName: "",
    pattern: "",
    navigationPath: "",
    toolArguments: "{}",
    result: "{}",
    durationMs: 0,
    success: false,
    errorMessage: "",
  };
}

export type AiSearchToolCallType =
  | AiSearchToolCall
  | AiSearchToolCallValuesType;

export function aiSearchToolCallDisplayId(
  source: Partial<AiSearchToolCall>,
  _langStore: LangStore
) {
  return (
    (source.sequence?.toString() ?? _langStore.emptyStringSymbol) +
    (source.toolName ?? _langStore.emptyStringSymbol)
  );
}

export function getAiSearchToolCallValues(
  source: AiSearchToolCallType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AiSearchToolCallValuesType {
  const entityValues = AiSearchToolCallValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : aiSearchToolCallDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.sequence = source.sequence || 0;
  entityValues.toolName = source.toolName;
  entityValues.pattern = source.pattern || "";
  entityValues.navigationPath = source.navigationPath || "";
  entityValues.toolArguments = source.toolArguments;
  entityValues.result = source.result || "";
  entityValues.durationMs = source.durationMs || 0;
  entityValues.success = source.success || false;
  entityValues.errorMessage = source.errorMessage || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getAiSearchToolCallUpdateInput(
  values: AiSearchToolCallValuesType
): AiSearchToolCall_UpdateInput {
  return {
    id: values.id,
    version_: values.version_,
    sequence: values.sequence,
    toolName: values.toolName,
    pattern: blankToNull(values.pattern),
    navigationPath: blankToNull(values.navigationPath),
    toolArguments: safeJsonParse(values.toolArguments, "toolArguments"),
    result: safeJsonParse(values.result, "result"),
    durationMs: values.durationMs,
    success: values.success,
    errorMessage: blankToNull(values.errorMessage),
  };
}

export function getAiSearchToolCallCreateInput(
  values: AiSearchToolCallValuesType
): AiSearchToolCall_CreateInput {
  return {
    sequence: values.sequence,
    toolName: values.toolName,
    pattern: blankToNull(values.pattern),
    navigationPath: blankToNull(values.navigationPath),
    toolArguments: safeJsonParse(values.toolArguments, "toolArguments"),
    result: safeJsonParse(values.result, "result"),
    durationMs: values.durationMs,
    success: values.success,
    errorMessage: blankToNull(values.errorMessage),
  };
}
